import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import home from '@/pages/home'
import ErrorPage from '@/pages/ErrorPage'
import httpRequest from "../network/http";

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: { keepAlive: true, title: '知分行', auth: true }
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: { keepAlive: true, title: '知分行', auth: true }
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorPage
    }
  ]
})

// token 校验函数
function verifyToken(token) {
  return httpRequest({
    url: '/user/agent/getCurrentTVAgent',
    method: 'post',
  })
}

router.beforeEach((to, from, next) => {
  if (!to.meta.auth) {
    next()
    return
  }

  const token = to.query.token || localStorage.getItem('token')
  if (!token) {
    next({
      path: '/error',
      query: { reason: 'no_token' }
    })
  } else {
    localStorage.setItem('token', token)
    verifyToken(token).then(res => {
      if (res.code === 200) {
        next()
      } else {
        localStorage.setItem('token', '')
        next({
          path: '/error',
          query: { reason: 'invalid_token' }
        })
      }
    }).catch(err => {
      next({
        path: '/error',
        query: { reason: 'network_error' }
      })
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js